import { request } from './client'

export const getEvents = () => request('/events')
